module.exports = __webpack_public_path__ + "static/img/order_click@2x.3e99fa3b.png";